/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View } from 'react-native';
import Images from '../images';
//@ts-ignore
import { JDDevice, JDText, JDImage } from '@jdreact/jdreact-core-lib';

const { getRpx, getFontSize } = JDDevice;
const styles = StyleSheet.create({
  wrap: {
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  textPlacehodler: {
    fontSize: getFontSize(30),
    color: '#BFBFBF',
  },
  noDataPlaceholder: {
    width: getRpx(308),
    height: getRpx(308),
    marginTop: getRpx(223),
    marginBottom: getRpx(30),
  },
});

const NoDataPlaceholder = (props: { text: string }) => {
  return (
    <View style={styles.wrap}>
      <JDImage source={Images.common.placeholder} style={styles.noDataPlaceholder}></JDImage>
      <JDText style={styles.textPlacehodler}>{props.text}</JDText>
    </View>
  );
};
export default NoDataPlaceholder;
